import loadable from '@loadable/component';
export const manifest = {
  ListVertical: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "ListVertical";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "ListVertical" */
          './list-vertical'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./list-vertical");
            }

            return eval('require.resolve')("./list-vertical");
          }

        }, {
          resolveComponent: mod => mod.ListVertical
        })
      }
    }
  },
  ListVerticalItem: {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "ListVerticalItem";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "ListVerticalItem" */
          './list-vertical-item'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./list-vertical-item");
            }

            return eval('require.resolve')("./list-vertical-item");
          }

        }, {
          resolveComponent: mod => mod.ListVerticalItem
        })
      }
    }
  }
};